import { useEffect } from 'react';

import config from 'config';

export const useDebounce = (
  callback: () => void,
  dependencyArray: unknown[],
  delay = config.defaultDebounceTime
): void => {
  useEffect(() => {
    const handler = setTimeout(() => {
      callback();
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [...dependencyArray, delay]); // eslint-disable-line react-hooks/exhaustive-deps
};
